import {axios} from "~/plugins/axios";

const getDefaultState_formReport = () => {
  return {}
}
const state = getDefaultState_formReport();

const getters = {}

const actions = {
  async loadDurationReport({ commit }, payload) {
    commit('shared/SET_LOADING', true, {root: true})

    let headers = {}
    try {
      if (payload.excel === true) {
        headers = {
          responseType: "blob",
        }
      }

      let resp = await axios.post('/api/reports/duration-talk-by-operators', payload, headers)
      if (payload.excel === true) {
        this._vm.utils.downloadXlsx(resp)
      } else if (payload.mail === true){
        this.dispatch('shared/setSuccess', resp.data)
      } else if (payload.excel === false && payload.mail === false) {
        return resp.data
      }

    } catch (err) {
      commit('shared/SET_ERROR', err.response.data, {root: true})

      throw err
    } finally {
      commit('shared/SET_LOADING', false, {root: true})

    }
  },
}

const mutations = {
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
